import PropTypes from 'prop-types';
import React, { PureComponent, PropsWithChildren } from 'react';
import listensToClickOutside from 'react-onclickoutside';
import './dropdown.scss';

type DropdownProps = {
    onClickOutside: () => void;
    seleniumId: string;
} & PropsWithChildren;

class Dropdown extends PureComponent<DropdownProps> {
    dropdownRef = React.createRef<HTMLDivElement>();

    static propTypes = {
        children: PropTypes.node,
        onClickOutside: PropTypes.func.isRequired,
    };

    static defaultProps = {
        children: null,
    };

    componentDidMount() {
        this.dropdownRef.current.addEventListener('focusout', event => {
            if (!this.dropdownRef.current.contains(event.relatedTarget as Node)) {
                this.handleClickOutside();
            }
        });
    }

    // eslint-disable-next-line react/no-unused-class-component-methods
    handleClickOutside = () => this.props.onClickOutside();

    onClick = e => {
        if (e?.target?.tagName === 'A') {
            this.handleClickOutside();
        }
    };

    onEscape = e => {
        if (e?.code === 'Escape') {
            this.handleClickOutside();
        }
    };

    render() {
        const { children, seleniumId } = this.props;

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
            <div
                ref={this.dropdownRef}
                className="resources-dropdown"
                data-seleniumid={seleniumId}
                onClick={this.onClick}
                onKeyDown={this.onEscape}
                role="menu"
            >
                {children}
            </div>
        );
    }
}

export default listensToClickOutside(Dropdown);
